export default __webpack_public_path__ + "static/lozenge-dropdown-dont-1-dark-5e63d8ee841971b6b8b97cf9e46227e5edb744317335bfc1b18421bf33f5fc55.png";